import { Hub } from "aws-amplify/utils";
import { getCurrentUser, fetchAuthSession } from "aws-amplify/auth";
import { Store } from "redux";
import { amplifyLogger } from "./AmplifyLogger";
import { signIn } from "./store/userSession/userSessionActions";
import { UserGroup } from "./gen/clients";

export class AuthEventListener {
  public static async init(store: Store): Promise<void> {
    const listener = (data: any) => {
      switch (data.payload.event) {
        case "signedIn":
          {
            amplifyLogger.info("user signed in");
            this.updateUserSession(store);
          }
          break;
        case "signedUp":
          amplifyLogger.info("user signed up");
          break;
        case "signedOut":
          amplifyLogger.info("user signed out");
          break;
        case "signInWithRedirect_failure":
          amplifyLogger.error("user sign in failed");
          break;
        case "tokenRefresh":
          amplifyLogger.info("token refresh succeeded");
          break;
        case "tokenRefresh_failure":
          amplifyLogger.error("token refresh failed");
          break;
        case "configured":
          amplifyLogger.info("the Auth module is configured");
          break;
        default: {
          // do nothing
        }
      }
    };

    Hub.listen("auth", listener);

    try {
      await this.updateUserSession(store);
    } catch (e) {
      amplifyLogger.info("User is not authenticated.", e);
    }
  }

  private static async updateUserSession(store: Store): Promise<void> {
    try {
      const user = await getCurrentUser();
      const session = await fetchAuthSession();
      const username = user.username;
      const email = this.getEmail(session);
      const userGroups = this.getUserGroups(session);
      store.dispatch(signIn(username, email || "", userGroups));
    } catch (e) {
      amplifyLogger.error("Failed to update user session", e);
    }
  }

  private static getUserGroups(session: any): UserGroup[] {
    const idToken = session?.tokens?.idToken;
    if (idToken) {
      const payload = idToken.payload;
      return payload["cognito:groups"] || [];
    }
    return [];
  }

  private static getEmail(session: any): string | undefined {
    const idToken = session?.tokens?.idToken;
    const email = idToken?.payload?.email;
    if (!email) {
      amplifyLogger.error("Email is not provided.");
    }
    return email;
  }
}

export default AuthEventListener;
